<template>
  <div class="trust-bar">
    <div class="trust-bar__inner">
      <div v-for="signal in signals" :key="signal.id" class="trust-signal">
        <span class="trust-signal__icon" v-html="signal.icon"></span>
        <div class="trust-signal__text">
          <p class="trust-signal__title">{{ signal.title }}</p>
          <p class="trust-signal__subtitle">{{ signal.subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const svg = (path: string) =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${path}</svg>`

const signals = [
  {
    id: 1,
    title: 'Datos seguros',
    subtitle: 'SSL + backups diarios',
    icon: svg('<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>'),
  },
  {
    id: 2,
    title: 'Empresa colombiana',
    subtitle: 'Facturación en COP',
    icon: svg('<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>'),
  },
  {
    id: 3,
    title: '99.9% Uptime',
    subtitle: 'Alta disponibilidad',
    icon: svg('<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>'),
  },
  {
    id: 4,
    title: 'Sin contrato anual',
    subtitle: 'Cancela cuando quieras',
    icon: svg('<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line><line x1="9.5" y1="13.5" x2="14.5" y2="18.5"></line><line x1="14.5" y1="13.5" x2="9.5" y2="18.5"></line>'),
  },
  {
    id: 5,
    title: 'Soporte en español',
    subtitle: 'Respuesta en <24h',
    icon: svg('<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>'),
  },
]
</script>

<style scoped>
.trust-bar {
  background: #F8F9FA;
  border-top: 1px solid #E5E7EB;
  border-bottom: 1px solid #E5E7EB;
  padding: 16px 0;
  font-family: 'Manrope', sans-serif;
}

.trust-bar__inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.trust-signal {
  display: flex;
  align-items: center;
  gap: 10px;
}

.trust-signal__icon {
  display: inline-flex;
  color: #129bef;
  flex: none;
}

.trust-signal__icon :deep(svg) {
  width: 24px;
  height: 24px;
  display: block;
}

.trust-signal__text {
  display: flex;
  flex-direction: column;
}

.trust-signal__title {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
}

.trust-signal__subtitle {
  font-size: 12px;
  color: #6B7280;
  margin: 0;
}

/* Mobile: scroll horizontal */
@media (max-width: 768px) {
  .trust-bar__inner {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .trust-bar__inner::-webkit-scrollbar {
    display: none;
  }

  .trust-signal {
    flex: none;
  }
}
</style>
